// NIHSS items with bilingual labels and options.
// Keep stable ids (used in result keys / tests).

export const NIHSS_ITEMS = [
  {
    id: "1a",
    label: { en: "1a. Level of consciousness", id: "1a. Tingkat kesadaran" },
    options: [
      { v: 0, en: "Alert, keenly responsive", id: "Sadar, sangat responsif" },
      { v: 1, en: "Drowsy (arouses to minor stimulation)", id: "Mengantuk (bangun pada stimulasi ringan)" },
      { v: 2, en: "Obtunded (requires repeated stimulation)", id: "Obtundasi (perlu stimulasi berulang)" },
      { v: 3, en: "Coma / unresponsive (reflex motor only)", id: "Koma / tidak responsif (hanya motorik refleks)" },
    ],
  },
  {
    id: "1b",
    label: { en: "1b. LOC Questions (month, age)", id: "1b. Pertanyaan Kesadaran (bulan, usia)" },
    options: [
      { v: 0, en: "Both answered correctly", id: "Keduanya benar" },
      { v: 1, en: "One answered correctly", id: "Satu benar" },
      { v: 2, en: "Neither answered correctly", id: "Tidak ada yang benar" },
    ],
  },
  {
    id: "1c",
    label: { en: "1c. LOC Commands (open/close eyes, grip)", id: "1c. Perintah Kesadaran (buka/tutup mata, genggam)" },
    options: [
      { v: 0, en: "Both performed correctly", id: "Keduanya dilakukan benar" },
      { v: 1, en: "One performed correctly", id: "Satu dilakukan benar" },
      { v: 2, en: "Neither performed correctly", id: "Tidak ada yang benar" },
    ],
  },
  {
    id: "2",
    label: { en: "2. Best gaze", id: "2. Tatapan terbaik" },
    options: [
      { v: 0, en: "Normal", id: "Normal" },
      { v: 1, en: "Partial gaze palsy", id: "Paresis tatapan parsial" },
      { v: 2, en: "Forced deviation", id: "Deviasi paksa" },
    ],
  },
  {
    id: "3",
    label: { en: "3. Visual fields", id: "3. Lapang pandang" },
    options: [
      { v: 0, en: "No visual loss", id: "Tidak ada gangguan" },
      { v: 1, en: "Partial hemianopia", id: "Hemianopia parsial" },
      { v: 2, en: "Complete hemianopia", id: "Hemianopia komplit" },
      { v: 3, en: "Bilateral hemianopia / blindness", id: "Hemianopia bilateral / buta" },
    ],
  },
  {
    id: "4",
    label: { en: "4. Facial palsy", id: "4. Paresis fasialis" },
    options: [
      { v: 0, en: "Normal symmetrical movement", id: "Gerakan simetris normal" },
      { v: 1, en: "Minor paralysis (flattened nasolabial fold)", id: "Paralisis ringan (lipatan nasolabial mendatar)" },
      { v: 2, en: "Partial paralysis (lower face)", id: "Paralisis parsial (wajah bawah)" },
      { v: 3, en: "Complete paralysis (upper & lower face)", id: "Paralisis komplit (wajah atas & bawah)" },
    ],
  },
  {
    id: "5a",
    label: { en: "5a. Motor arm — LEFT", id: "5a. Motorik lengan — KIRI" },
    options: [
      { v: 0, en: "No drift (holds 90°/45° for 10s)", id: "Tidak melayang (tahan 90°/45° 10 dtk)" },
      { v: 1, en: "Drift before 10s", id: "Melayang sebelum 10 dtk" },
      { v: 2, en: "Some effort against gravity", id: "Sedikit melawan gravitasi" },
      { v: 3, en: "No effort against gravity", id: "Tidak melawan gravitasi" },
      { v: 4, en: "No movement", id: "Tidak ada gerakan" },
    ],
  },
  {
    id: "5b",
    label: { en: "5b. Motor arm — RIGHT", id: "5b. Motorik lengan — KANAN" },
    options: [
      { v: 0, en: "No drift", id: "Tidak melayang" },
      { v: 1, en: "Drift before 10s", id: "Melayang sebelum 10 dtk" },
      { v: 2, en: "Some effort against gravity", id: "Sedikit melawan gravitasi" },
      { v: 3, en: "No effort against gravity", id: "Tidak melawan gravitasi" },
      { v: 4, en: "No movement", id: "Tidak ada gerakan" },
    ],
  },
  {
    id: "6a",
    label: { en: "6a. Motor leg — LEFT", id: "6a. Motorik tungkai — KIRI" },
    options: [
      { v: 0, en: "No drift (holds 30° for 5s)", id: "Tidak melayang (tahan 30° 5 dtk)" },
      { v: 1, en: "Drift before 5s", id: "Melayang sebelum 5 dtk" },
      { v: 2, en: "Some effort against gravity", id: "Sedikit melawan gravitasi" },
      { v: 3, en: "No effort against gravity", id: "Tidak melawan gravitasi" },
      { v: 4, en: "No movement", id: "Tidak ada gerakan" },
    ],
  },
  {
    id: "6b",
    label: { en: "6b. Motor leg — RIGHT", id: "6b. Motorik tungkai — KANAN" },
    options: [
      { v: 0, en: "No drift", id: "Tidak melayang" },
      { v: 1, en: "Drift before 5s", id: "Melayang sebelum 5 dtk" },
      { v: 2, en: "Some effort against gravity", id: "Sedikit melawan gravitasi" },
      { v: 3, en: "No effort against gravity", id: "Tidak melawan gravitasi" },
      { v: 4, en: "No movement", id: "Tidak ada gerakan" },
    ],
  },
  {
    id: "7",
    label: { en: "7. Limb ataxia", id: "7. Ataksia ekstremitas" },
    options: [
      { v: 0, en: "Absent", id: "Tidak ada" },
      { v: 1, en: "Present in one limb", id: "Ada di satu ekstremitas" },
      { v: 2, en: "Present in two or more limbs", id: "Ada di dua atau lebih ekstremitas" },
    ],
  },
  {
    id: "8",
    label: { en: "8. Sensory", id: "8. Sensorik" },
    options: [
      { v: 0, en: "Normal", id: "Normal" },
      { v: 1, en: "Mild–moderate sensory loss", id: "Gangguan sensorik ringan–sedang" },
      { v: 2, en: "Severe to total sensory loss", id: "Gangguan sensorik berat hingga total" },
    ],
  },
  {
    id: "9",
    label: { en: "9. Best language", id: "9. Bahasa terbaik" },
    options: [
      { v: 0, en: "No aphasia", id: "Tidak afasia" },
      { v: 1, en: "Mild–moderate aphasia", id: "Afasia ringan–sedang" },
      { v: 2, en: "Severe aphasia", id: "Afasia berat" },
      { v: 3, en: "Mute / global aphasia", id: "Bisu / afasia global" },
    ],
  },
  {
    id: "10",
    label: { en: "10. Dysarthria", id: "10. Disartria" },
    options: [
      { v: 0, en: "Normal articulation", id: "Artikulasi normal" },
      { v: 1, en: "Mild–moderate slurring", id: "Pelo ringan–sedang" },
      { v: 2, en: "Severe, unintelligible / mute", id: "Berat, tidak jelas / bisu" },
    ],
  },
  {
    id: "11",
    label: { en: "11. Extinction / inattention", id: "11. Ekstingsi / inatensi" },
    options: [
      { v: 0, en: "No abnormality", id: "Tidak ada kelainan" },
      { v: 1, en: "Inattention to one modality", id: "Inatensi pada satu modalitas" },
      { v: 2, en: "Profound hemi-inattention", id: "Hemi-inatensi berat" },
    ],
  },
];

export const ALVARADO_CRITERIA = [
  { id: "m", points: 1, group: "symptoms", en: "Migration of pain to RLQ", id_lang: "Nyeri berpindah ke RLQ" },
  { id: "a", points: 1, group: "symptoms", en: "Anorexia", id_lang: "Anoreksia" },
  { id: "n", points: 1, group: "symptoms", en: "Nausea / vomiting", id_lang: "Mual / muntah" },
  { id: "t", points: 2, group: "signs", en: "Tenderness in RLQ", id_lang: "Nyeri tekan di RLQ" },
  { id: "r", points: 1, group: "signs", en: "Rebound tenderness", id_lang: "Nyeri lepas" },
  { id: "e", points: 1, group: "signs", en: "Elevated temperature (≥ 37.3 °C / 99.1 °F)", id_lang: "Suhu meningkat (≥ 37.3 °C / 99.1 °F)" },
  { id: "l", points: 2, group: "labs", en: "Leukocytosis (WBC > 10 000 /mm³)", id_lang: "Leukositosis (WBC > 10.000 /mm³)" },
  { id: "s", points: 1, group: "labs", en: "Shift to left (neutrophils > 75 %)", id_lang: "Shift to left (neutrofil > 75 %)" },
];
